export const DIALOG_ID = "DIALOG";

export const DIALOGS = {
    ADBLOCKER_DETECTED: "ADBLOCKER_DETECTED",
    CANCEL_EXIT_CONFIRM: "CANCEL_EXIT_CONFIRM",
    CHANGE_DURATION_CONFIRM: "CHANGE_DURATION_CONFIRM",
    CHANGE_DURATION_FORM: "CHANGE_DURATION_FORM",
    CLAIM_CONFIRM: "CLAIM_CONFIRM",
    DEPOSIT_CONFIRM: "DEPOSIT_CONFIRM",
    DEPOSIT_MORE_FORM: "DEPOSIT_MORE_FORM",
    EXIT_FEEDBACK: "EXIT_FEEDBACK",
    EXIT_RETAIN_WHALE: "EXIT_RETAIN_WHALE",
    JOIN_WAITLIST: "JOIN_WAITLIST",
    LOCK_CONFIRM: "LOCK_CONFIRM",
    LOCK_FORM: "LOCK_FORM",
    LOCK_MORE_FORM: "LOCK_MORE_FORM",
    MINT_CONFIRM: "MINT_CONFIRM",
    POINTS_NEW_CHAPTER: "POINTS_NEW_CHAPTER",
    REALLOCATE_POINTS: "REALLOCATE_POINTS",
    REDEEM_CONFIRM: "REDEEM_CONFIRM",
    REDEEM_FORM_ALT: "REDEEM_FORM_ALT",
    REDEEM_FORM: "REDEEM_FORM",
    VOTE_SUBMIT: "VOTE_SUBMIT",
    VOTE_SUCCESS: "VOTE_SUCCESS",
    WAITLIST_INTERCEPTOR: "WAITLIST_INTERCEPTOR",
    WHALE_RETENTION: "WHALE_RETENTION",
    WITHDRAW_CONFIRM: "WITHDRAW_CONFIRM",
    WITHDRAW_FORM: "WITHDRAW_FORM",
    WITHDRAW_LOCK_CONFIRM: "WITHDRAW_LOCK_CONFIRM",
    WITHDRAW_LOCK_FORM: "WITHDRAW_LOCK_FORM",
    WITHDRAW_UNWOUND_CONFIRM: "WITHDRAW_UNWOUND_CONFIRM",
} as const;

export type DialogType = keyof typeof DIALOGS;
